import React, { useContext, useEffect, useRef, useState } from "react";
import NavSub from "../components/NavSub";
import {
  CaretLeft,
  CaretRight,
  CaretDown,
  ClockCountdown,
  Download,
  FileArrowUp,
} from "@phosphor-icons/react";
import {
  clientApiUrl,
  taskApiUrl,
  notificationApiUrl,
  userApiUrl,
} from "../utils/GetUrl";
import "../Styles/ActivitywisetimereportNav.css";
import "../Styles/UserwiseTimeReportNav.css";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import ArrowDropUpIcon from "@mui/icons-material/ArrowDropUp";
import Footerweek from "../components/Footerweek";
import Userwise1 from "../components/Userwise1";
import Userwise2 from "../components/Userwise2";
import Userwise3 from "../components/Userwise3";
import Connectuser from "../pages/Connectuser";
import { faCaretDown } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { UserContext } from "../context/UserContext";
import {
  Select,
  MenuItem,
  Checkbox,
  ListItemText,
  FormControl,
  InputLabel,
  FormControlLabel,
  Radio,
  RadioGroup,
  Button,
  Menu,
} from "@mui/material";
import { cleanDigitSectionValue } from "@mui/x-date-pickers/internals/hooks/useField/useField.utils";
import { AuthContext } from "../context/AuthContext";
import { CaretUp, Cursor } from "phosphor-react";
import ToastComponent from "../components/ToastComponent";

function UserwiseTimeReport() {
  const {
    teamsData,
    setTeamsData,
    teamNames,
    setTeamNames,
    usersList,
    fetchTeams,
  } = useContext(UserContext);
  const { token, logout } = useContext(AuthContext);
  // const [selectedDate, setSelectedDate] = useState('');
  const [chosenDate, setChosenDate] = useState("");
  const [teams, setTeams] = useState(
    teamNames?.filter(
      (team) =>
        team?.superTeamId === 0 && team?.type === "T" && team?.status === true
    )
  );
  const [selectedTeams, setSelectedTeams] = useState([]);
  const [selectedEmployees, setSelectedEmployees] = useState(usersList);
  const [timeCode, setTimeCode] = useState(null);
  const [department, setDepartment] = useState(null);
  const [uniqueDepartments, setUniqueDepartments] = useState([]);
  const [selectedDepartment, setSelectedDepartment] = useState("");
  const [selectedIds, setSelectedIds] = useState("");
  const [selectedCostCenters, setSelectedCostCenters] = useState("");
  const [anchorEl, setAnchorEl] = useState(null);
  const [uniqueTimeCodes, setUniqueTimeCodes] = useState([]);
  const [selectedTimeCode, setSelectedTimeCode] = useState("");
  const [selectedTimeCodeIds, setSelectedTimeCodeIds] = useState("");
  const [menuAnchor, setMenuAnchor] = useState(null);
  const [downloadFile, setDownloadFile] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);

  useEffect(() => {
    setSelectedEmployees(usersList);
  }, [usersList]);
  useEffect(() => {
    setTeams(
      teamNames?.filter(
        (team) =>
          team?.superTeamId === 0 && team?.type === "T" && team?.status === true
      )
    );
  }, [teamNames]);

  const handleDateChange = (event) => {
    setSelectedDate(event.target.value);
  };

  const currentDate = new Date();
  const currentMonthYear = `${currentDate.getFullYear()}-${String(
    currentDate.getMonth() + 1
  ).padStart(2, "0")}`;

  const [selectedDate, setSelectedDate] = useState(currentMonthYear);

  const isOpen = Boolean(anchorEl);
  const isMenuOpen = Boolean(menuAnchor);

  const handleDownload = () => {
    const link = document.createElement("a");

    link.href = "path_to_your_file";

    link.download = "filename.ext";

    document.body.appendChild(link);
    link.click();

    document.body.removeChild(link);
  };

  const handleProceed = () => {
    // Update the chosen date only when the PROCEED button is clicked
    setChosenDate(selectedDate);
    setdatebellDropdownOpen(!isdateDropdownOpen);
  };

  // ////////////////////////////////////////////////////////////////////////////////////////////////////////
  const [isdateDropdownOpen, setdatebellDropdownOpen] = useState(false);

  const [isDateDropdownOpen, setIsDateDropdownOpen] = useState(false);

  const toggledateDropdown = () => {
    setdatebellDropdownOpen(!isdateDropdownOpen);
  };

  const dropdown2Ref = useRef(null);
  const closeDateDropdown = () => {
    setdatebellDropdownOpen(false);
  };

  useEffect(() => {
    const handleClick2Outside = (event) => {
      if (
        dropdown2Ref.current &&
        !dropdown2Ref.current.contains(event.target)
      ) {
        setdatebellDropdownOpen(false);
      }
    };

    const handleScroll = () => {
      closeDateDropdown();
    };

    document.addEventListener("mousedown", handleClick2Outside);
    window.addEventListener("scroll", handleScroll);
    return () => {
      document.removeEventListener("mousedown", handleClick2Outside);
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  const handleChange = (event) => {
    //console.log(event.target.value);
    if (event.target.value?.[event.target.value?.length - 1] === undefined) {
      //console.log("mmmmmmmmmmmmmmmm");
      setSelectedTeams([]);
      return;
    }
    setSelectedTeams(event.target.value);
  };
  const handleClearAll = (event) => {
    event.preventDefault();

    setSelectedTeams([]);
  };

  useEffect(() => {
    const filteredEmployees = usersList?.filter((user) =>
      selectedTeams?.includes(parseInt(user?.STM_Team))
    );
    setSelectedEmployees(filteredEmployees);
    //console.log(filteredEmployees);
  }, [selectedTeams, usersList, token]);

  useEffect(() => {
    //console.log(selectedTeams.length);
    if (!selectedTeams?.length) {
      //console.log("this");
      setSelectedEmployees(usersList);
    }
  }, [selectedTeams, token]);

  useEffect(() => {
    const uniqueNames = [...new Set(department?.map((dept) => dept.name))];
    setUniqueDepartments(uniqueNames);
  }, [department, token]);

  const handleOpen = (event) => {
    setAnchorEl(event.currentTarget);
    setOpen((prev) => !prev);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleDeptChange = (event) => {
    const name = event.currentTarget.getAttribute("data-value");
    setSelectedDepartment(name);

    const ids = department
      ?.filter((dept) => dept.name === name)
      .map((dept) => dept.id)
      .join(",");
    setSelectedIds(ids);
    const costCenters = department
      ?.filter((dept) => dept.name === name)
      .map((dept) => `'${dept.costCenter}'`)
      .join(",");
    setSelectedCostCenters(costCenters);
    handleClose();
  };

  useEffect(() => {
    const uniqueCodes = [
      ...new Set(timeCode?.map((code) => code.AL_SalseforceCode)),
    ];
    setUniqueTimeCodes(uniqueCodes);
  }, [timeCode]);

  const handleMenuOpen = (event) => {
    setMenuAnchor(event.currentTarget);
    setMenuOpen((prev) => !prev);
  };

  const handleMenuClose = () => {
    setMenuAnchor(null);
  };

  const handleTimeCodeChange = (event) => {
    const code = event.currentTarget.getAttribute("data-value");
    setSelectedTimeCode(code);

    const ids = timeCode
      ?.filter((item) => item.AL_SalseforceCode === code)
      .map((item) => item.AL_ID)
      .join(",");
    setSelectedTimeCodeIds(ids);
    handleMenuClose();
  };
  const toastRef = useRef();

  const fetchDepartments = async () => {
    if (!token) {
      return;
    }
    try {
      // setLoading(true);

      // Check if token is present
      // if (!token) {
      //   toastRef.current.showToast('Please Login to access', 'error');
      //   await logout();
      //   return;
      // }

      const response = await fetch(
        `${clientApiUrl}/GetAllDepartment?Page=1&ItemsPerPage=500`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      if (response.status === 401) {
        toastRef.current.showToast(
          "Unauthorised access. Please login again.",
          "error"
        );
        await logout();
        return;
      }

      // Check for authentication error
      // const handleAuthError = await handleAuthExpiry(response);
      // if (handleAuthError) {
      //   toastRef.current.showToast("Your Session has expired", "error");
      //   logout();
      //   return;
      // }

      if (response.ok) {
        const data = await response.json();
        setDepartment(data);
        // setDepartment2(data);
      } else {
        console.error("Network response was not ok");
        // Show error toast message or handle the error as needed
      }

      // setLoading(false);
    } catch (error) {
      console.error("Error fetching data:", error);
      // Show error toast message or handle the error as needed
    }
  };
  const fetchTimeCode = async () => {
    if (!token) {
      return;
    }
    try {
      // setLoading(true);

      // Check if token is present
      // if (!token) {
      //   toastRef.current.showToast('Please Login to access', 'error');
      //   await logout();
      //   return;
      // }

      const response = await fetch(
        `${clientApiUrl}/GetAllActivity?Page=1&ItemsPerPage=500`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      if (response.status === 401) {
        toastRef.current.showToast(
          "Unauthorised access. Please login again.",
          "error"
        );
        await logout();
        return;
      }
      // Check for authentication error
      // const handleAuthError = await handleAuthExpiry(response);
      // if (handleAuthError) {
      //   toastRef.current.showToast("Your Session has expired", "error");
      //   logout();
      //   return;
      // }

      if (response.ok) {
        const data = await response.json();
        setTimeCode(data?.filter((item) => item?.AL_Status == "1"));
        // setDepartment2(data);
      } else {
        console.error("Network response was not ok");
        // Show error toast message or handle the error as needed
      }

      // setLoading(false);
    } catch (error) {
      console.error("Error fetching data:", error);
      // Show error toast message or handle the error as needed
    }
  };

  useEffect(() => {
    if (token) {
      fetchDepartments();
      fetchTimeCode();
    }
  }, [token]);

  const [teamSelectorOpen, setTeamSelectorOpen] = useState(false);

  const toggleTeamSelector = () => {
    setTeamSelectorOpen((prev) => !prev);
  };

  const [open, setOpen] = useState(false);

  return (
    <>
      <NavSub />
      <div className="Voucher-acc-timereports">
        <div>
          <div className="main-drop-userwise">
            <ToastComponent ref={toastRef} timeout={4000} />

            <FormControl className="select-dropdown-user">
              <InputLabel
                id="team-selector-label"
                className="select-dropdown-label"
                shrink={false}
                onClick={toggleTeamSelector}
                style={{
                  display: "flex",
                  alignItems: "center",
                  cursor: "pointer",
                }} // Ensures clickable area
              >
                SELECT TEAMS
              </InputLabel>

              <Select
                labelId="team-selector-label"
                id="team-selector"
                multiple
                value={selectedTeams}
                onChange={handleChange}
                renderValue={(selected) =>
                  selected
                    .map((teamId) => {
                      const team = teams.find((team) => team.id === teamId);
                      return team?.Name;
                    })
                    .join(" ")
                }
                style={{ width: "150px" }}
                MenuProps={{
                  PaperProps: {
                    style: {
                      maxHeight: 250,
                    },
                  },
                }}
              >
                {selectedTeams?.length > 0 && (
                  <MenuItem onClick={(e) => handleClearAll(e)}>
                    <ListItemText
                      style={{ color: "red" }}
                      primary={"Clear All"}
                    />
                  </MenuItem>
                )}
                {teams.map((team) => (
                  <MenuItem key={team.id} value={team.id}>
                    <Checkbox checked={selectedTeams.indexOf(team.id) > -1} />
                    <ListItemText primary={team.name} />
                  </MenuItem>
                ))}
              </Select>
            </FormControl>

            <div>
              <Button
                aria-controls="timecode-menu"
                aria-haspopup="true"
                onClick={handleMenuOpen}
                className="drop-time"
                endIcon={
                  isMenuOpen ? <ArrowDropUpIcon /> : <ArrowDropDownIcon />
                }
              >
                {selectedTimeCode ? selectedTimeCode : "Time Code"}
              </Button>
              <Menu
                id="timecode-menu"
                anchorEl={menuAnchor}
                keepMounted
                open={Boolean(menuAnchor)}
                onClose={handleMenuClose}
                className="drop-menu-time"
              >
                <MenuItem
                  onClick={() => {
                    setSelectedTimeCode();
                  }}
                >
                  {" "}
                  <ListItemText style={{ color: "red" }} primary={"Clear"} />
                </MenuItem>

                {uniqueTimeCodes?.map((code, index) => (
                  <MenuItem
                    key={index}
                    data-value={code}
                    onClick={handleTimeCodeChange}
                  >
                    <ListItemText primary={code} />
                  </MenuItem>
                ))}
              </Menu>
              {/* {selectedTimeCodeIds && (
  <div>
    Selected IDs: {selectedTimeCodeIds}
  </div>
)} */}
            </div>

            <div>
              <Button
                aria-controls="simple-menu"
                aria-haspopup="true"
                onClick={handleOpen}
                className="drop-department"
                endIcon={isOpen ? <ArrowDropUpIcon /> : <ArrowDropDownIcon />}
              >
                {selectedDepartment ? selectedDepartment : "Department"}
              </Button>
              <Menu
                id="simple-menu"
                anchorEl={anchorEl}
                keepMounted
                open={Boolean(anchorEl)}
                onClose={handleClose}
                className="drop-menu-dept"
              >
                <MenuItem
                  onClick={() => {
                    setSelectedDepartment();
                    setSelectedIds();
                    setSelectedCostCenters();
                  }}
                >
                  {" "}
                  <ListItemText style={{ color: "red" }} primary={"Clear"} />
                </MenuItem>
                {uniqueDepartments.map((name, index) => (
                  <MenuItem
                    key={index}
                    data-value={name}
                    onClick={handleDeptChange}
                  >
                    <ListItemText primary={name} />
                  </MenuItem>
                ))}
              </Menu>
            </div>

            <div className="Voucher-cust-name" onClick={toggledateDropdown}>
              <div className="date-range-user">
                <div className="date-title-designuser">DATE RANGE</div>
                <div className="caret-icon-user" onClick={toggledateDropdown}>
                  {isDateDropdownOpen ? (
                    <CaretUp size={16} weight="fill" />
                  ) : (
                    <CaretDown size={16} weight="fill" />
                  )}
                </div>
              </div>
            </div>

            {isdateDropdownOpen && (
              <div ref={dropdown2Ref} className="Icon-Drop-voucher-timereports">
                <div className="drop-date">
                  <div>
                    {/* <div className="drop-content-2">
                      Select A Custom Month Of Your Choice
                    </div> */}
                    {/* <div className='drop-contentf'> */}
                    <input
                      className="date-userwise"
                      type="month"
                      value={selectedDate}
                      onChange={handleDateChange}
                    />
                    {/* </div> */}
                  </div>

                  <div className="drop-button">
                    {" "}
                    <button
                      className="drop-button-design"
                      onClick={handleProceed}
                    >
                      PROCEED
                    </button>{" "}
                  </div>
                </div>
              </div>
            )}
          </div>
        </div>
        <div>
          <div className="Nav-btn-user">
            <FileArrowUp size={25} color="#3d025f" weight="fill" />
            <button
              className="Nav-Sub-btn"
              onClick={() => {
                setDownloadFile(true);
              }}
            >
              DOWNLOAD FILES
            </button>
          </div>
        </div>
      </div>

      <div className="time-report-nav">
        <div className="content-timereport">WORKING DAYS</div>
      </div>
      <>
        <Userwise2
          downloadFile={downloadFile}
          setDownloadFile={setDownloadFile}
          selectedIds={selectedIds}
          selectedCostCenters={selectedCostCenters}
          selectedTimeCode={selectedTimeCode}
          timeCode={timeCode}
          department={department}
          selectedDate={chosenDate}
          teams={teams}
          selectedTeams={selectedTeams}
          setSelectedTeams={setSelectedTeams}
          selectedEmployees={selectedEmployees}
        />
      </>
    </>
  );
}

export default UserwiseTimeReport;
